import { api } from './client';
import type { Envelope } from './types';

export interface ChatMessage {
  id: string;
  userId: string;
  nickname: string;
  content: string;
  createdAt: string;
}

export interface ChatPage {
  items: ChatMessage[];
  nextCursor: string | null;
}

interface ListEnvelope {
  data?: ChatMessage[] | null;
  meta?: { nextCursor?: string | null; limit?: number };
  traceId: string;
}

/** 최신순 커서 페이지 (items: 최신 → 과거). */
export async function listMessages(
  meetingId: string,
  cursor?: string | null,
  limit = 30,
): Promise<ChatPage> {
  const params = new URLSearchParams();
  params.set('limit', String(limit));
  if (cursor) params.set('cursor', cursor);
  const { data } = await api.get<ListEnvelope>(
    `/meetings/${meetingId}/messages?${params.toString()}`,
  );
  return { items: Array.isArray(data.data) ? data.data : [], nextCursor: data.meta?.nextCursor ?? null };
}

/** 폴링용: afterId 이후 새 메시지 (오래된 순). */
export async function listNewMessages(
  meetingId: string,
  afterId: string,
): Promise<ChatMessage[]> {
  const { data } = await api.get<ListEnvelope>(
    `/meetings/${meetingId}/messages?afterId=${encodeURIComponent(afterId)}`,
  );
  return Array.isArray(data.data) ? data.data : [];
}

export async function sendMessage(meetingId: string, content: string): Promise<ChatMessage> {
  const { data } = await api.post<Envelope<ChatMessage>>(
    `/meetings/${meetingId}/messages`,
    { content },
  );
  return data.data;
}
